import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, RoutingModule, UrlModule } from '@spartacus/core';
import { CarouselModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CustomProductService } from 'src/app/service/product/custom-product.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { SlickCarouselUtilService } from 'src/app/utility/slick-carousel.util';
import { PromotionalTextModule } from '../../promotional-text/promotional-text.module';
import { TooltipIconModule } from '../../tooltip-icon/tooltip-icon.module';
import { AlternativeProductsComponent } from './alternative-products.component';

@NgModule({
  imports: [
    CommonModule,
    OutletModule,
    I18nModule,
    RouterModule,
    CarouselModule,
    MediaModule,
    RoutingModule,
    UrlModule,
    SlickCarouselModule,
    PromotionalTextModule,
    MatIconModule,
    TooltipIconModule,
    SharedModule,
    AlternativeProductsComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AlternativeProducts: {
          component: AlternativeProductsComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    CustomProductService,
    SlickCarouselUtilService,
  ],
  exports: [AlternativeProductsComponent],
})
export class AlternativeProductsModule {}
